export const messages = {
  en: {
    inspectionRoute: {
      routeName: 'Route Name',
      routeNamePlaceholder: 'Please enter route name',
      routeNameRequired: 'Route name is required',
      routeNameMaxLength: 'Route name cannot exceed 100 characters',
      sequence: 'Sequence',
      sequencePlaceholder: 'Please enter sequence number',
      sequenceRequired: 'Sequence is required',
      sequenceMustBeNumber: 'Sequence must be a number',
      remark: 'Remark',
      remarkPlaceholder: 'Please enter remark',
      remarkMaxLength: 'Remark cannot exceed 200 characters',
      routeInfo: 'Route Information',
      createTime: 'Create Time',
      confirmDeleteRoute: 'Are you sure to delete this inspection route?',
      confirmDeletePoint: 'Are you sure to delete this inspection point?',
      addRouteTitle: 'Add Inspection Route',
      editRouteTitle: 'Edit Inspection Route',
      addSuccess: 'Added successfully',
      editSuccess: 'Modified successfully',
      deleteSuccess: 'Deleted successfully',
      addFailed: 'Failed to add',
      editFailed: 'Failed to modify',
      deleteFailed: 'Failed to delete',
      routeIdRequired: 'Route ID is required',
      pointId: 'Point ID',
      pointName: 'Point Name',
      pointType: 'Point Type',
      pointLocation: 'Location',
      startTime: 'Start Time',
      endTime: 'End Time',
      sortNumber: 'Sort',
      startTimeRequired: 'Start time is required',
      endTimeRequired: 'End time is required',
      sortNumberRequired: 'Sort number is required',
      sortNumberMustBeNumber: 'Sort number must be a number',
      startTimePlaceholder: 'Please enter start time',
      endTimePlaceholder: 'Please enter end time',
      sortNumberPlaceholder: 'Please enter sort number',
      choosePointTitle: 'Select Inspection Points',
      pointNamePlaceholder: 'Please enter point name',
      choosePointWarning: 'Please select at least one inspection point',
      editPointTitle: 'Edit Inspection Point',
      planName: 'Plan Name',
      planRoute: 'Route',
      planCycle: 'Cycle',
      signType: 'Sign Type',
      dateRange: 'Date Range',
      timeRange: 'Time Range',
      taskAdvance: 'Advance (minutes)',
      creator: 'Creator',
      inspector: 'Inspector',
      status: 'Status'
    }
  },
  zh: {
    inspectionRoute: {
      routeName: '路线名称',
      routeNamePlaceholder: '请输入路线名称',
      routeNameRequired: '路线名称不能为空',
      routeNameMaxLength: '路线名称不能超过100个字符',
      sequence: '顺序',
      sequencePlaceholder: '请输入顺序号',
      sequenceRequired: '顺序不能为空',
      sequenceMustBeNumber: '顺序必须是数字',
      remark: '备注',
      remarkPlaceholder: '请输入备注',
      remarkMaxLength: '备注不能超过200个字符',
      routeInfo: '路线信息',
      createTime: '创建时间',
      confirmDeleteRoute: '确定删除此巡检路线吗？',
      confirmDeletePoint: '确定删除此巡检点吗？',
      addRouteTitle: '添加巡检路线',
      editRouteTitle: '修改巡检路线',
      addSuccess: '添加成功',
      editSuccess: '修改成功',
      deleteSuccess: '删除成功',
      addFailed: '添加失败',
      editFailed: '修改失败',
      deleteFailed: '删除失败',
      routeIdRequired: '路线ID不能为空',
      pointId: '巡检点ID',
      pointName: '巡检点名称',
      pointType: '巡检点类型',
      pointLocation: '巡检位置',
      startTime: '开始时间',
      endTime: '结束时间',
      sortNumber: '排序',
      startTimeRequired: '开始时间不能为空',
      endTimeRequired: '结束时间不能为空',
      sortNumberRequired: '排序不能为空',
      sortNumberMustBeNumber: '排序必须是数字',
      startTimePlaceholder: '请输入开始时间',
      endTimePlaceholder: '请输入结束时间',
      sortNumberPlaceholder: '请输入排序值',
      choosePointTitle: '选择巡检点',
      pointNamePlaceholder: '请输入巡检点名称',
      choosePointWarning: '请至少选择一个巡检点',
      editPointTitle: '修改巡检点',
      planName: '计划名称',
      planRoute: '计划路线',
      planCycle: '计划周期',
      signType: '签到方式',
      dateRange: '日期范围',
      timeRange: '时间范围',
      taskAdvance: '任务提前(分钟)',
      creator: '制定人',
inspector: '巡检人',
      status: '状态'
    }
  },
  'zh-TW': {
    inspectionRoute: {
      routeName: '路線名稱',
      routeNamePlaceholder: '請輸入路線名稱',
      routeNameRequired: '路線名稱不能為空',
      routeNameMaxLength: '路線名稱不能超過100個字符',
      sequence: '順序',
      sequencePlaceholder: '請輸入順序號',
      sequenceRequired: '順序不能為空',
      sequenceMustBeNumber: '順序必須是數字',
      remark: '備註',
      remarkPlaceholder: '請輸入備註',
      remarkMaxLength: '備註不能超過200個字符',
      routeInfo: '路線信息',
      createTime: '創建時間',
      confirmDeleteRoute: '確定刪除此巡檢路線嗎？',
      confirmDeletePoint: '確定刪除此巡檢點嗎？',
      addRouteTitle: '添加巡檢路線',
      editRouteTitle: '修改巡檢路線',
      addSuccess: '添加成功',
      editSuccess: '修改成功',
      deleteSuccess: '刪除成功',
      addFailed: '添加失敗',
      editFailed: '修改失敗',
      deleteFailed: '刪除失敗',
      routeIdRequired: '路線ID不能為空',
      pointId: '巡檢點ID',
      pointName: '巡檢點名稱',
      pointType: '巡檢點類型',
      pointLocation: '巡檢位置',
      startTime: '開始時間',
      endTime: '結束時間',
      sortNumber: '排序',
      startTimeRequired: '開始時間不能為空',
      endTimeRequired: '結束時間不能為空',
      sortNumberRequired: '排序不能為空',
      sortNumberMustBeNumber: '排序必須是數字',
      startTimePlaceholder: '請輸入開始時間',
      endTimePlaceholder: '請輸入結束時間',
      sortNumberPlaceholder: '請輸入排序值',
      choosePointTitle: '選擇巡檢點',
      pointNamePlaceholder: '請輸入巡檢點名稱',
      choosePointWarning: '請至少選擇一個巡檢點',
      editPointTitle: '修改巡檢點',
      planName: '計劃名稱',
      planRoute: '計劃路線',
      planCycle: '計劃週期',
      signType: '簽到方式',
      dateRange: '日期範圍',
      timeRange: '時間範圍',
      taskAdvance: '任務提前(分鐘)',
      creator: '制定人',
      inspector: '巡檢人',
      status: '狀態'
    }
  }
}